<template>
  <div>
    <!-- Performance Franquias Table -->
    <performance-franquias-table
      ref="performanceFranquiasTableRef">
    </performance-franquias-table>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { log } from '../../utils/DebugLogger';

interface DataTableInstance {
  loadData: () => void;
}

// Reactive data
const performanceFranquiasTableRef = ref<DataTableInstance | null>(null);

// Methods
const loadData = async () => {
  if (performanceFranquiasTableRef.value) {
    await performanceFranquiasTableRef.value.loadData();
  }
};

// Lifecycle
onMounted(() => {
  log('PerformanceFranquiasPage', 'mounted', 'Component mounted');
});

onBeforeUnmount(() => {
  log('PerformanceFranquiasPage', 'beforeUnmount', 'Cleaning up');
});

// Expose methods for parent components
defineExpose({
  loadData
});
</script>

<style scoped>
</style>
